import Component from "react-pure-render/component";
import React, { PropTypes } from "react";
import {
  isFieldWrong,
  isFormValid
} from "../../common/lib/validationAllFields";
import {
  addNotificationsForInvalidFields,
  focusInvalidField
} from "../lib/validationWeb";
import Modal from "../components/modal.react";
import InputCustom from "../components/inputCustom.react";

export default class FormSubmission extends Component {
  static propTypes = {
    msg: React.PropTypes.object
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { actions, notificationSystem, params: { uid } } = this.props;
    actions.getFormSubmission(uid).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      }
    });
  }

  updateFormSubmission = () => {
    const {
      actions,
      formSubmissions: { formSubmissions: { entities: formSubmissions } },
      params: { uid },
      notificationSystem
    } = this.props;
    const formSubmission = formSubmissions.get(uid);
    actions
      .updateFormSubmission(formSubmission.toJS(), uid)
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        }
      });
  };

  render() {
    const {
      actions,
      formSubmissions: { formSubmissions: { entities: formSubmissions } },
      params: { uid }
    } = this.props;
    const formSubmission = formSubmissions ? formSubmissions.get(uid) : null;
    const inputCustomCustomProps = formSubmission
      ? {
          feature: "formSubmissions",
          actions: actions,
          entity: formSubmission,
          uid: formSubmission ? formSubmission.get("uid") : null
        }
      : {
          feature: "formSubmissions",
          actions: actions,
          entity: formSubmission,
          uid: undefined
        };

    const content = formSubmission
      ? formSubmission.get("content").map(function(item, index) {
          return (
            <div className="row middle-xs" key={index}>
              <div className="col-xs-12 col-sm-4">{item.get("label")}</div>
              <div className="col-xs-12 col-sm-8">
                {item.get("fieldType") === "text" && (
                  <input readOnly value={item.get("value")} />
                )}
                {item.get("fieldType") === "textarea" && (
                  <textarea readOnly value={item.get("value")} />
                )}
              </div>
            </div>
          );
        })
      : "";

    return (
      <div className="islogged-page">
        <div className="row">
          <div className="col-xs-12">
            <h2>
              Wiadomość z: {formSubmission ? formSubmission.get("name") : ""}
            </h2>
            <div className="box-wrapper">
              <div className="title">Szczegóły wiadomości</div>
              <div className="content-wrapper">{content}</div>
            </div>
            <button className="success" onClick={this.updateFormSubmission}>
              zatwierdź zmiany
            </button>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/formSubmission/formSubmission.react.js